var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 406,
    viewBox: "0 0 515 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.37,
    d: "M64.9908 330.381H13.5622C-0.204065 316.079 -3.88038 293.292 4.33141 275.223C12.1736 257.993 28.9968 246.619 39.1866 230.678C60.9449 196.698 50.4354 145.968 79.9958 118.464C94.7711 104.721 116.02 100.744 136.14 99.1347C156.26 97.5257 177.039 97.5756 195.64 89.7502C218.617 80.1057 235.88 59.3878 259.507 51.5823C286.04 42.8174 317.778 53.751 333.283 77.0076C342.983 91.5591 346.65 109.839 358.118 123.041C376.669 144.378 409.357 146.028 432.494 162.288C440.416 167.927 447.061 175.173 451.994 183.555C456.928 191.936 460.039 201.264 461.125 210.93C463.593 234.216 454.751 260.671 468.718 279.48C475.521 288.645 486.56 293.812 493.892 302.567C501.225 311.322 503.263 319.237 500.965 330.381H64.9908Z",
    fill: "#9FEBFB"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.37,
    d: "M78.1363 330.381H26.6977C12.9414 316.079 9.25512 293.292 17.4769 275.223C25.3191 257.993 42.1423 246.619 52.3321 230.678C74.0904 196.698 63.5709 145.968 93.1313 118.464C107.917 104.721 129.165 100.744 149.275 99.1347C169.385 97.5257 190.234 97.5756 208.786 89.7502C231.763 80.1057 249.016 59.3878 272.652 51.5823C299.186 42.8174 330.924 53.751 346.428 77.0076C356.129 91.5591 359.785 109.839 371.264 123.041C389.815 144.378 422.502 146.028 445.639 162.288C453.56 167.928 460.204 175.175 465.137 183.556C470.071 191.937 473.183 201.265 474.271 210.93C476.738 234.216 467.897 260.671 481.853 279.48C488.666 288.645 499.705 293.812 507.038 302.567C514.371 311.322 516.399 319.237 514.101 330.381H78.1363Z",
    fill: "#A3A1FB"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.51 154.192L194.392 154.262H3.12345L2.66392 154.322C0.765812 141.629 10.6559 128.737 23.1934 125.339C34.1225 122.34 46.9097 125.009 56.0606 118.343C64.2624 112.346 66.3003 101.163 71.665 92.5377C75.0243 87.145 79.7313 82.7219 85.3213 79.7051C92.3144 75.9573 100.996 74.6481 108.149 78.0361C120.816 84.0326 123.243 100.843 131.715 112.016C133.603 114.515 135.981 116.844 139.008 117.673C141.795 118.443 144.752 117.843 147.609 117.333C156.97 115.684 168.199 115.834 174.023 123.33C176.76 126.868 177.739 131.405 179.258 135.603C180.776 139.8 183.254 144.128 187.469 145.597C189.467 146.307 191.775 146.326 193.553 147.516C195.701 148.975 196.38 151.523 196.51 154.192Z",
    fill: "url(#paint0_linear_1476_110518)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.162 178.358H281.115C280.25 177.089 279.729 175.617 279.601 174.087C279.473 172.556 279.743 171.019 280.385 169.623C282.034 165.975 285.47 163.497 288.897 161.438C292.323 159.379 295.97 157.44 298.537 154.442C303.462 148.556 303.173 140.11 304.261 132.515C305.54 123.52 309.316 114.525 316.13 108.529C318.864 106.156 321.93 104.197 325.23 102.712C334.571 98.3647 346.14 97.2753 354.871 102.712C363.222 107.949 367.318 117.913 374.601 124.559C376.263 126.229 378.328 127.441 380.595 128.077C387.119 129.577 392.663 123.66 397.578 119.083C404.571 112.596 413.822 107.749 423.253 108.959C434.341 110.398 442.913 119.952 447.119 130.276C448.877 134.594 450.216 139.371 453.712 142.439C462.703 150.305 477.828 141.49 488.288 147.206C492.214 149.355 494.841 153.263 496.939 157.201C500.429 163.836 502.866 170.974 504.162 178.358Z",
    fill: "url(#paint1_linear_1476_110518)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.095 302.157H176.051V330.37H137.18V302.157H79.0781V273.244L139.678 184.605H176.051V272.744H192.095V302.157ZM137.15 272.744V255.754C137.15 252.562 137.267 248.258 137.5 242.841C137.538 239.992 137.721 237.147 138.049 234.316H136.95C134.767 239.294 132.202 244.096 129.278 248.678L113.134 272.664L137.15 272.744Z",
    fill: "#111112"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.484 302.166H165.43V330.38H126.569V302.166H68.457V273.253L129.057 184.614H165.43V272.753H181.484V302.166ZM126.539 272.753V255.763C126.539 252.572 126.656 248.267 126.889 242.85C127.122 237.434 127.302 234.592 127.428 234.325H126.369C124.182 239.304 121.614 244.105 118.687 248.687L102.543 272.673L126.539 272.753Z",
    fill: "url(#paint2_linear_1476_110518)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.741 303.136L440.156 274.253L429.737 276.252L424.402 277.251L407.679 190.711L371.954 197.627L329.287 296.16L334.772 324.554L391.825 313.51L395.071 330.33H434.662L429.987 306.134L435.321 305.135L445.741 303.136ZM375.811 286.706L362.654 289.244L372.044 267.077L373.942 262.59C375.942 257.534 377.548 252.331 378.748 247.029L379.827 246.829C380.043 249.67 380.403 252.499 380.906 255.304C381.705 260.634 382.407 264.881 383.013 268.046L386.23 284.687L375.811 286.706Z",
    fill: "#111112"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.321 305.155L429.736 276.282L413.982 279.33L397.249 192.79L371.954 197.677L361.535 199.676L318.867 298.219L324.352 326.602L334.771 324.604L381.405 315.609L384.262 330.4H423.852L419.567 308.223L429.986 306.224L435.321 305.155ZM372.054 267.077C372.244 268.166 372.434 269.156 372.604 270.075L375.82 286.716L352.234 291.283L363.533 264.608C365.533 259.557 367.14 254.357 368.338 249.057L369.417 248.848C369.632 251.689 369.992 254.518 370.496 257.323C371.065 261.14 371.585 264.398 372.054 267.077Z",
    fill: "url(#paint3_linear_1476_110518)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.52 256.443H173.794L158.739 146.037C158.739 146.037 136.95 122.231 111.945 117.773L135.762 115.185L189.438 116.644L197.52 256.443Z",
    fill: "#9FEBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.862 195.738C103.862 195.738 90.3756 215.477 96.3696 232.437L121.455 195.738L118.198 191.361L103.862 195.738Z",
    fill: "#111023"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.793 256.443L172.984 261.54C172.984 261.54 165.831 262.54 165.432 272.754H184.033L194.133 262.89L195.072 256.443H173.793Z",
    fill: "#111023"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.083 145.937L115.343 144.828L120.178 190.391L100.018 197.617L88.3995 141.35C87.6054 138.892 87.3684 136.289 87.7056 133.728C88.0429 131.168 88.9461 128.714 90.3495 126.547C91.7529 124.379 93.6213 122.551 95.819 121.196C98.0167 119.841 100.489 118.993 103.055 118.713L111.916 117.713C136.931 122.211 158.739 146.037 158.739 146.037L145.083 145.937Z",
    fill: "#9FEBFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.316 18.7609V20.1101L88.7076 20.32C88.4079 19.576 87.9669 18.8972 87.4089 18.3212C85.2611 16.4722 83.7626 15.0031 82.2241 15.9026C81.0653 16.5722 81.1552 19.7603 81.2251 21.2595L76.8395 21.8191L37.9883 26.7463V26.6763C40.5058 26.0867 42.4638 21.5593 42.4638 16.0625C42.4638 10.5657 40.5657 6.16822 38.0982 5.46863L90.306 11.3552V18.7809L90.316 18.7609Z",
    fill: "url(#paint4_linear_1476_110518)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9069 8.29697C40.7976 8.45426 40.6975 8.61777 40.6072 8.78669C40.1764 9.92733 39.6725 11.039 39.0987 12.1148C38.5882 12.8529 37.8677 13.4204 37.0307 13.7438C36.1365 14.0313 35.2106 14.2092 34.2735 14.2735C33.6443 14.333 33.0278 14.488 32.4453 14.7332C32.735 9.54625 34.783 5.50859 37.3005 5.37866L38.1097 5.46861C38.7447 5.72328 39.3206 6.10574 39.8018 6.59227C40.2829 7.0788 40.6591 7.65902 40.9069 8.29697Z",
    fill: "url(#paint5_linear_1476_110518)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4548 15.173C41.8154 16.0325 41.5057 17.1019 40.9063 17.9814C40.2021 19.0567 39.1109 19.8191 37.8593 20.1102C36.7405 20.36 35.5217 20.2201 34.4927 20.7398C33.9765 21.015 33.5423 21.4219 33.234 21.9191C32.6704 20.0117 32.391 18.0315 32.4048 16.0425C32.4048 15.5928 32.4048 15.1531 32.4547 14.7133C33.0373 14.4681 33.6537 14.3131 34.2829 14.2536C35.22 14.1893 36.1459 14.0114 37.0402 13.7239C37.8708 13.4042 38.5873 12.8439 39.0981 12.1148C39.6711 11.0455 40.175 9.94057 40.6066 8.80673C40.6969 8.63781 40.797 8.4743 40.9063 8.31702C41.8898 10.471 42.417 12.8053 42.4548 15.173Z",
    fill: "url(#paint6_linear_1476_110518)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4754 16.0427C42.4754 21.5395 40.4774 26.0369 37.9998 26.6565C37.814 26.705 37.6225 26.7285 37.4304 26.7265C35.6722 26.7265 34.1237 24.8176 33.2246 21.9193C33.5329 21.422 33.9672 21.0151 34.4833 20.7399C35.4823 20.2202 36.7311 20.3602 37.85 20.1103C39.0752 19.82 40.1456 19.0776 40.847 18.0315C41.4464 17.152 41.7561 16.0327 42.3954 15.2231C42.4654 15.453 42.4754 15.7428 42.4754 16.0427Z",
    fill: "url(#paint7_linear_1476_110518)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.086 13.4246H136.76C135.44 13.8921 134.202 14.5668 133.094 15.4234C132.594 15.8831 132.814 16.7127 133.424 17.792H121.086V13.4246Z",
    fill: "#111023"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M155.902 16.113V17.852H147.39C146.737 16.4179 146.19 14.9382 145.752 13.4246H155.902V16.113Z",
    fill: "#111023"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.086 17.8016V18.7711H90.3164V12.3948H121.086V13.4342V17.8016Z",
    fill: "#26AE65"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5352 29.6446L84.8119 34.8016C84.8119 34.8016 76.5901 26.1766 76.9198 21.8092L81.3054 21.2495C81.2055 19.7504 81.1156 16.5622 82.3044 15.8926C83.8429 14.9931 85.3014 16.4623 87.4892 18.3112C88.0472 18.8873 88.4882 19.5661 88.7879 20.31C89.9814 23.3329 90.9008 26.457 91.5352 29.6446Z",
    fill: "url(#paint8_linear_1476_110518)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9597 5.48895C45.5001 4.48953 44.0416 5.33904 44.4911 6.31848C45.8615 9.26101 46.4948 12.4932 46.3364 15.7355C46.178 18.9779 45.2326 22.1328 43.582 24.9277C43.4977 25.1188 43.4868 25.3343 43.5513 25.533C43.6158 25.7317 43.7512 25.8997 43.9317 26.0048C44.1121 26.1099 44.325 26.1448 44.5296 26.1028C44.7341 26.0608 44.916 25.9449 45.0406 25.7772C46.8258 22.7232 47.8423 19.2808 48.0024 15.7465C48.1625 12.2122 47.4615 8.692 45.9597 5.48895Z",
    fill: "#111023"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M166.592 36.4608V41.6878L160.338 35.7712L166.592 36.4608Z",
    fill: "url(#paint9_linear_1476_110518)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 41.6779L172.894 47.6744L178.888 53.3512C178.888 53.3512 192.704 43.6568 197.998 43.5768C198.363 43.5675 198.728 43.5943 199.087 43.6568C203.803 44.3164 206.68 49.7732 205.861 55.0002C204.962 60.6269 205.121 66.8633 199.707 67.8727C194.292 68.8821 170.396 74.6888 170.396 74.6888L144.242 39.1994L147.329 37.1006L154.192 32.2934L155.581 31.2939L158.578 34.1423L160.326 35.7913L166.59 41.6779Z",
    fill: "url(#paint10_linear_1476_110518)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.474 37.54L199.088 43.6565C198.729 43.594 198.364 43.5672 197.999 43.5765C192.665 43.6565 178.898 53.3009 178.898 53.3009L172.904 47.6242L183.474 37.54Z",
    fill: "url(#paint11_linear_1476_110518)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.699 67.8726L190.628 92.5783L189.409 116.644C189.409 116.644 188.35 116.834 186.502 117.094C177.85 118.323 151.936 121.282 135.733 115.185L142.046 85.2925L139.129 61.7162L103.914 65.6139L81.8164 37.1005L84.8134 34.8018L91.5866 29.6448L112.426 50.0929L145.113 35.8012C145.806 36.3085 146.55 36.7438 147.331 37.1005L144.244 39.2492L170.398 74.7386C170.398 74.7386 194.284 68.892 199.699 67.8726Z",
    fill: "url(#paint12_linear_1476_110518)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.194 32.243L147.331 37.1002C146.551 36.7499 145.807 36.3213 145.113 35.8209C144.152 35.2141 143.332 34.4073 142.71 33.4554C142.087 32.5035 141.677 31.4287 141.507 30.3041C141.217 26.8461 135.373 21.2094 133.465 17.8513C132.856 16.772 132.636 15.9424 133.135 15.4827C134.244 14.6261 135.481 13.9514 136.802 13.4839C140.428 12.0447 145.263 11.0653 145.703 13.304C145.715 13.3651 145.731 13.4253 145.753 13.4839C146.193 14.9805 146.74 16.4435 147.391 17.8613C149.879 23.598 154.194 32.243 154.194 32.243Z",
    fill: "#FFB27D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.38,
    d: "M190.636 92.578C150.626 84.0729 144.242 39.199 144.242 39.199L170.396 74.7084L199.697 67.8723L190.636 92.578Z",
    fill: "url(#paint13_linear_1476_110518)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.244 15.7231C183.464 15.6382 183.7 15.6059 183.933 15.6285C184.167 15.6511 184.393 15.7281 184.592 15.8533C184.791 15.9786 184.958 16.1486 185.079 16.3498C185.201 16.551 185.274 16.7779 185.292 17.0123C186.081 20.1105 182.615 23.8184 182.615 23.8184L183.474 37.5404L172.895 47.6246L177.031 35.7714L166.591 36.451L160.347 35.7714L158.599 34.1024C158.599 34.1024 157.38 22.739 157.38 16.1128C157.348 14.8858 157.425 13.6584 157.61 12.445L157.66 12.1152C164.973 13.3544 175.122 10.4961 175.122 10.4961C175.122 10.4961 176.551 24.3581 178.489 24.5979C180.427 24.8378 181.046 17.0623 181.046 17.0623C181.684 16.4756 182.431 16.0205 183.244 15.7231Z",
    fill: "#FFB27D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.334 5.64862L183.244 15.7228C182.434 16.0053 181.687 16.4432 181.046 17.012C181.046 17.012 180.436 24.7875 178.488 24.5477C176.54 24.3078 175.122 10.4458 175.122 10.4458C175.122 10.4458 164.972 13.3042 157.659 12.1149C155.552 11.8925 153.575 10.991 152.025 9.54636C146.43 3.64978 148.368 0.301723 156.39 2.13066C164.412 3.9596 181.026 -5.76476 183.334 5.64862Z",
    fill: "#111023"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M177.029 35.7712L172.884 47.6344L166.59 41.6878V36.4608L177.029 35.7712Z",
    fill: "#ED975D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M472.175 330.38H71.3149C71.3149 330.38 49.7465 344.712 81.8144 347.13C113.882 349.549 163.902 351.847 162.664 362.761C161.425 373.675 132.474 371.526 132.474 390.745C132.474 409.964 266.04 405.566 266.04 405.566C266.04 405.566 341.495 406.566 352.234 393.803C362.974 381.04 321.825 369.367 329.257 364.33C336.69 359.293 390.966 374.394 399.048 362.171C407.13 349.949 397.439 342.233 412.344 340.614C427.249 338.995 469.667 344.921 472.175 330.38Z",
    fill: "#B0D4FF"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M441.864 364.39C458.604 364.39 472.174 360.529 472.174 355.765C472.174 351.002 458.604 347.14 441.864 347.14C425.125 347.14 411.555 351.002 411.555 355.765C411.555 360.529 425.125 364.39 441.864 364.39Z",
    fill: "#D7E9FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.177 369.778C133.809 369.778 145.671 366.842 145.671 363.221C145.671 359.601 133.809 356.665 119.177 356.665C104.545 356.665 92.6836 359.601 92.6836 363.221C92.6836 366.842 104.545 369.778 119.177 369.778Z",
    fill: "#D7E9FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M271.025 394.573C287.644 394.573 301.115 391.978 301.115 388.777C301.115 385.575 287.644 382.98 271.025 382.98C254.407 382.98 240.936 385.575 240.936 388.777C240.936 391.978 254.407 394.573 271.025 394.573Z",
    fill: "#E9FDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M310.817 253.265C304.643 239.147 293.064 230.352 276.081 226.88C274.237 226.501 272.428 226.201 270.657 225.981C255.672 224.082 243.314 227.66 233.584 236.715C222.695 246.829 214.656 264.575 209.468 289.954C206.291 305.511 205.405 318.974 206.811 330.34H243.933C243.467 323.678 244.773 312.83 247.85 297.799C251.18 281.522 254.476 270.528 257.74 264.818C259.638 261.487 261.786 259.298 264.183 258.252C265.939 257.481 267.896 257.292 269.768 257.712C274.523 258.692 277.26 262.56 277.979 269.316C278.699 276.072 277.443 287.365 274.213 303.196C271.789 315.063 269.355 324.114 266.91 330.35H307.59C309.612 324.012 311.28 317.566 312.585 311.042C313.531 306.378 314.277 301.92 314.823 297.669C317.154 279.5 315.818 264.698 310.817 253.265Z",
    fill: "#111112"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300.416 251.146C294.875 238.467 284.945 230.082 270.626 225.991C269.021 225.531 267.356 225.124 265.631 224.771C248.188 221.2 234.022 224.478 223.133 234.606C212.244 244.733 204.209 262.493 199.027 287.885C197.968 293.048 197.166 297.989 196.62 302.706C195.39 311.893 195.39 321.203 196.62 330.39H233.693C233.643 330.15 233.613 329.91 233.583 329.66C232.804 323.191 234.062 311.864 237.359 295.68C240.689 279.403 243.989 268.409 247.259 262.699C250.529 256.989 254.525 254.621 259.247 255.593C261.095 255.935 262.784 256.864 264.062 258.242C265.91 260.241 267.059 263.239 267.459 267.187C268.178 273.949 266.923 285.243 263.693 301.067C260.975 314.339 258.248 324.097 255.511 330.34H296.4C298.763 323.332 300.695 316.187 302.184 308.942C307.173 284.53 306.583 265.264 300.416 251.146Z",
    fill: "url(#paint14_linear_1476_110518)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M328.757 155.902L328.508 156.102L302.404 176.42L286.11 189.113L272.544 226.661L268.777 225.312L282.753 186.654L326.31 152.744L328.757 155.902Z",
    fill: "#2A2A2A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M341.264 240.193C338.267 243.721 334.271 246.19 330.275 248.488L330.005 248.018C331.573 246.02 333.232 243.651 332.762 241.142C332.286 239.462 331.276 237.981 329.885 236.925C327.697 234.996 325.26 233.367 323.172 231.338C320.966 229.399 319.486 226.766 318.976 223.872C318.536 220.075 320.584 216.487 321.384 212.749C321.789 211.264 321.73 209.691 321.214 208.242C319.875 205.063 315.829 204.334 312.622 203.055C309.755 201.895 307.058 199.746 306.259 196.758C305.1 192.421 308.187 187.983 307.767 183.516C307.582 181.962 306.987 180.486 306.042 179.238C305.098 177.991 303.838 177.018 302.393 176.42L328.497 156.092C332.922 159.93 336.738 165.017 336.788 170.823C336.788 174.501 335.32 177.999 334.261 181.517C333.753 182.906 333.575 184.395 333.741 185.865C334.151 188.083 335.919 189.762 337.547 191.331C340.914 194.559 344.301 198.487 344.241 203.154C344.181 208.391 339.715 213.059 340.495 218.236C340.994 221.544 343.542 224.182 344.56 227.36C345.969 231.758 344.231 236.665 341.264 240.193Z",
    fill: "#6366F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1476_110518",
    x1: 99.47,
    y1: 76.0806,
    x2: 99.47,
    y2: 154.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E9FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1476_110518",
    x1: 391.866,
    y1: 99.0317,
    x2: 391.866,
    y2: 178.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E9FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1476_110518",
    x1: 30046.6,
    y1: 56020.1,
    x2: 29843.7,
    y2: 48003.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1476_110518",
    x1: 60552.2,
    y1: 52224.6,
    x2: 60376.6,
    y2: 44655.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1476_110518",
    x1: 37.9983,
    y1: 16.0825,
    x2: 90.316,
    y2: 16.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ADC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#55AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#74BFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8FCDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A5D89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B6E194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1E78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C8EA8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1476_110518",
    x1: 40.9069,
    y1: 10.036,
    x2: 32.4453,
    y2: 10.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#89E9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84E2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7DD7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#72C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#64B0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5395F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1476_110518",
    x1: 1857.57,
    y1: 797.103,
    x2: 1756.36,
    y2: 797.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#36C6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3CB7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1476_110518",
    x1: 1713.35,
    y1: 749.603,
    x2: 1627.68,
    y2: 749.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#89E9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84E2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7DD7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#72C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#64B0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5395F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1476_110518",
    x1: 76.8599,
    y1: 25.2072,
    x2: 91.5352,
    y2: 25.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F7BC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7B67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7AC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F79E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1476_110518",
    x1: 163.525,
    y1: 36.4309,
    x2: 163.045,
    y2: 54.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1476_110518",
    x1: 19579.9,
    y1: 3483.79,
    x2: 19540.2,
    y2: 5264.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1476_110518",
    x1: 8696.28,
    y1: 1297.62,
    x2: 8691.63,
    y2: 1576.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1476_110518",
    x1: 26133.8,
    y1: 10490.4,
    x2: 40045.1,
    y2: 10490.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1476_110518",
    x1: 144.242,
    y1: 65.8935,
    x2: 199.707,
    y2: 65.8935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F0987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#470E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#561588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6B1F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1476_110518",
    x1: 43115.1,
    y1: 40952.3,
    x2: 43002.5,
    y2: 35065.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FCF1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FEF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5eb109a8f8ad763db5307f2bf8e3b581.svg";
export { ForwardRef as ReactComponent };